// extracted by mini-css-extract-plugin
export default {"main":"CustomPagesEdit_main__yZOvG"};